import React, { Fragment, useEffect, useState, useRef } from 'react'
import { Link } from 'react-router-dom';
import {  formatDbDateWithoutTime, formatDbTime } from '../../../utils/dateFormater';
import DefaultAvatar from "../../images/default_avatar.jpg"
import { formatWhatsAppNumber } from '../../../utils/whatsappLinkFormater';
import HoverFullText from '../../../elements/HoverToolKit';
import SingleOrderButtons from './SingleOrderButtons';

const SingleReservation = ({ order, user, productTypes }) => {




    const [copied, setCopied] = useState(false);
    const [showActionButtons, setShowActionButtons] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowActionButtons(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);




    const handleCopy = async (value) => {
        try {
            await navigator.clipboard.writeText(value);
            setCopied(true);

            setTimeout(() => {
                setCopied(false);
            }, 1500);
        } catch (err) {
            console.error("Failed to copy:", err);
        }
    };













    const handleClassName = (orderStatus) => {


        if (orderStatus === "ORDERED") return "text-green-600 bg-green-100";
        if (orderStatus === "REVIEWED") return "text-pink-500 bg-pink-100";
        if (orderStatus === "DELIVERED") return "text-orange-500 bg-orange-100";
        if (orderStatus === "SUSPENDED") return "text-orange-500 bg-orange-100";
        if (orderStatus === "ON_HOLD") return "text-blue-500 bg-blue-100";
        if (orderStatus === "REFUNDED") return "text-green-600 bg-green-100";
        if (orderStatus === "COMMISSIONED") return "text-slate-500 bg-slate-100";
        if (orderStatus === "COMPLETED") return "text-purple-500 bg-purple-100";
        if (orderStatus === "CANCELLED") return "text-[#B04926] bg-[#b0482637]";
        if (orderStatus === "REVIEW_DELETED") return "text-red-500 bg-red-100";
        if (orderStatus === "SYSTEM_CANCELLED") return "text-red-500 bg-red-100";
        if (orderStatus === "ORDER_CANCELLED_BY_PMM") return "text-red-500 bg-red-100";
        if (orderStatus === "CANCELLED_BY_ADMIN") return "text-red-500 bg-red-100";
        if (orderStatus === "REFUNDED_PENDING_REVIEW") return "text-orange-500 bg-orange-100";

    }












    return (
        <Fragment>
            <div 
                className="grid py-[1vmax] items-center border-b border-gray-100 last:border-b-0 hover:bg-gray-50 transition-colors"
                style={{ gridTemplateColumns: (user?.role === 'PMM' || user?.role === 'ADMIN' || user?.role === 'SUPER_ADMIN') 
                    ? 'minmax(0, 0.8fr) minmax(0, 1.5fr) minmax(0, 1.2fr) minmax(0, 1.5fr) minmax(0, 2.5fr) minmax(0, 0.8fr) minmax(0, 3fr) minmax(0, 0.8fr) minmax(0, 1fr) minmax(0, 2fr) minmax(0, 1.5fr) minmax(0, 1fr) minmax(0, 2.5fr)' 
                    : 'minmax(0, 0.8fr) minmax(0, 1.5fr) minmax(0, 1.5fr) minmax(0, 2.5fr) minmax(0, 0.8fr) minmax(0, 3fr) minmax(0, 0.8fr) minmax(0, 1fr) minmax(0, 2fr) minmax(0, 1.5fr) minmax(0, 1fr) minmax(0, 2.5fr)' }}
            >
                {/* Order ID */}
                <div className="text-center text-[#4c4c5c] font-semibold text-[1.6vmax] lg:text-[0.8vmax] " >
                    #{order?.id}
                </div>

                {/* Seller (PMM) */}
                <div className="flex flex-col items-center justify-center text-[#4c4c5c] text-[1.6vmax] lg:text-[0.8vmax]" >
                    <a href={formatWhatsAppNumber(order?.pmm_country_code, order?.pmm_phone_number)} target="_blank" rel="noopener noreferrer" className="hover:scale-110 transition-transform">
                        <i className="fa-brands fa-whatsapp text-green-600 text-[2vmax]"></i>
                    </a>
                    <div className='text-center font-semibold text-gray-700 capitalize tracking-tight leading-tight'>
                        <HoverFullText text={order?.pmm_name} sliceLength={12} />
                    </div>
                </div>

                {/* Chinese Seller */}
                {(user?.role === 'PMM' || user?.role === 'ADMIN' || user?.role === 'SUPER_ADMIN') &&
                    <div className="text-center text-gray-600 font-semibold text-[1.6vmax] lg:text-[0.8vmax] capitalize" >
                        <HoverFullText text={order?.chinese_seller || "N/A"} sliceLength={10} />
                    </div>
                }

                {/* Ordered By (PM) */}
                <div className="flex flex-col items-center justify-center text-[#4c4c5c] text-[1.6vmax] lg:text-[0.8vmax]" >
                    <a href={formatWhatsAppNumber(order?.pm_country_code, order?.pm_phone_number)} target="_blank" rel="noopener noreferrer" className="hover:scale-110 transition-transform">
                        <i className="fa-brands fa-whatsapp text-green-600 text-[2vmax]"></i>
                    </a>
                    <div className='text-center font-semibold text-gray-700 capitalize tracking-tight leading-tight'>{order?.pm_name}</div>
                </div>

                {/* Order Number */}
                <div className="text-center text-gray-700 font-medium text-[1.6vmax] lg:text-[0.8vmax]" >
                    <HoverFullText text={order?.order_number || "N/A"} sliceLength={25} />
                </div>

                {/* Product Image */}
                <div className="flex-center">
                    <div className="w-[8vmax] aspect-square flex-center rounded-lg overflow-hidden shadow-sm border border-gray-100" >
                        <img src={order?.custom_image || DefaultAvatar} alt="" className="w-full h-full object-cover" />
                    </div>
                </div>



                {/* Customer Email */}
                <div className="text-center text-gray-600 font-medium text-[1.6vmax] lg:text-[0.8vmax] lowercase" >
                    <HoverFullText text={order?.paypal_email || "N/A"} sliceLength={35} />
                </div>

                {/* Market */}
                <div className="text-center text-indigo-600 font-semibold text-[1.6vmax] lg:text-[0.8vmax] uppercase" >
                    {order?.market || "N/A"}
                </div>

                {/* Product ID */}
                <div className="text-center text-gray-700 font-medium text-[1.6vmax] lg:text-[0.8vmax] flex gap-2 items-center justify-center" >
                    <span>{order?.product_id}</span>
                    <button
                        onClick={() => handleCopy(order?.product_id)}
                        className="text-gray-400 hover:text-indigo-600 transition-colors"
                        title={copied ? "Copied" : "Copy"}
                    >
                        <i className={`fa-regular ${copied ? "fa-circle-check text-green-600" : "fa-copy"} text-[1.6vmax] lg:text-[0.8vmax]`}></i>
                    </button>
                </div>

                {/* Product Type */}
                <div className="flex justify-center text-[#4c4c5c] text-[1.6vmax] lg:text-[0.8vmax] " >
                    {(order?.product_type_name || (productTypes?.length > 0 && productTypes.filter(prev => prev.id === order?.product_type_id)[0]?.name)) ? (
                        <span className='inline-flex items-center whitespace-nowrap bg-indigo-50 text-indigo-600 p-[0.3vmax_0.8vmax] rounded-full font-bold border border-indigo-100 shadow-sm' >
                            <i className="fa-regular fa-file-lines mr-2"></i>
                            <HoverFullText text={order?.product_type_name || productTypes.filter(prev => prev.id === order?.product_type_id)[0]?.name} sliceLength={20} />
                        </span>
                    ) : (
                        <span className='text-zinc-400 font-medium'>N/A</span>
                    )}
                </div>

                {/* Ordered At */}
                <div className="text-center text-gray-500 font-medium text-[1.6vmax] lg:text-[0.8vmax] leading-tight" >
                    <div>
                        {formatDbDateWithoutTime(order?.created_at)}
                        <div className="text-[1vmax] lg:text-[0.7vmax] text-gray-400 mt-1">{formatDbTime(order?.created_at)}</div>
                    </div>
                </div>

                {/* Report Column */}
                <div className="flex-center">
                    {(user?.role === "PMM" || user?.role === "PM") ? (
                        <Link to={`/orders/report-order?order_id=${order?.id}`} className="px-[1.2vmax] py-[0.5vmax] flex-center bg-red-50 text-red-600 rounded-md hover:bg-red-100 border border-red-200 transition-colors text-[1.6vmax] lg:text-[0.8vmax] font-semibold whitespace-nowrap" >
                            Report
                        </Link>
                    ) : (
                        <span className="text-zinc-400">-</span>
                    )}
                </div>

                {/* Status & Action Buttons */}
                <div className="flex items-center justify-center gap-[0.5vmax] relative" ref={dropdownRef}>
                    {/* View Button */}
                    <Link to={`/orders/order-details?order_id=${order.id}`} className="px-[1.2vmax] py-[0.5vmax] flex-center bg-blue-50 text-blue-600 rounded-md hover:bg-blue-100 border border-blue-200 transition-colors text-[1.6vmax] lg:text-[0.8vmax] font-semibold whitespace-nowrap" >
                        View
                    </Link>
 
                    {/* Status Button */}
                    <button className={`px-[1.2vmax] py-[0.5vmax] flex-center rounded-md border transition-colors text-[1.6vmax] lg:text-[0.8vmax] font-semibold whitespace-nowrap ${handleClassName(order?.status)}`}
                        onClick={() => setShowActionButtons(!showActionButtons)}
                    >
                        {order?.status === "ON_HOLD" ? "HOLD" : 
                         order?.status === "REVIEW_DELETED" ? "DEL" : 
                         order?.status === "SYSTEM_CANCELLED" ? "SYS CANCEL" : 
                         order?.status === "ORDER_CANCELLED_BY_PMM" ? "PMM CANCEL" :
                         order?.status === "CANCELLED_BY_ADMIN" ? "ADMIN CANCEL" :
                         order?.status === "REFUNDED_PENDING_REVIEW" ? "REF PENDING" :
                         order?.status}
                        <i className="fa-solid fa-chevron-down ml-1 text-[1.2vmax] lg:text-[0.75vmax]"></i>
                    </button>

                    {showActionButtons &&
                        <div className="absolute top-full right-0 mt-2 z-[50]">
                            <SingleOrderButtons order={order} user={user} setShowActionButtons={setShowActionButtons} />
                        </div>
                    }
                </div>
            </div>
        </Fragment>
    )
}

export default SingleReservation